import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="select-kit-header-wrapper">
  <span class="filter-text">
    {{i18n "user.user_notifications.filters.filter_by"}}
  </span>
  <span class="header-text">
    {{i18n this.label}}
  </span>
  {{d-icon this.caretIcon class="caret-icon"}}
</div>
*/
{
  "id": "kgLf34t3",
  "block": "[[[10,0],[14,0,\"select-kit-header-wrapper\"],[12],[1,\"\\n  \"],[10,1],[14,0,\"filter-text\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"user.user_notifications.filters.filter_by\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,1],[14,0,\"header-text\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[[30,0,[\"label\"]]],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[1,[28,[35,1],[[30,0,[\"caretIcon\"]]],[[\"class\"],[\"caret-icon\"]]]],[1,\"\\n\"],[13]],[],false,[\"i18n\",\"d-icon\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/notifications-filter/notifications-filter-header.hbs",
  "isStrictMode": false
});